export const TriggerEffects = Object.freeze({
    Hotspot: 'Hotspot',
    Pager: 'Pager',
    Presentation: 'Presentation',
    Play: 'Play',
    Pause: 'Pause',
    Restart: 'Restart',
    Next: 'Next',
    Previous: 'Previous',
    Home: 'Home',
    Custom: 'Custom'
});

export const HoverEffects = Object.freeze({
    Scale: 'Scale',
    BorderScale: 'BorderScale',
    PauseCountdown: 'PauseCountdown',
    Custom: 'Custom'
});

export const UIPieces = Object.freeze({
    Border: 'Border',
    Close: 'Close',
    Title: 'Title'
});

export const DefaultSizing = Object.freeze({
    Height: 1, //how tall the text is, width is based upon the message
    Scale: 100, //the higher the scale, the more crisp text will look
    TextOffset: .1,  //we can't have text/icons with the same 'z' position, since that clips into each other
    Distance: 10, //the distance for something to be easily read. Anything closer and it becomes harder to read
});

export const InteractionValues = Object.freeze({
    VideoSphereRadius: 256, //pulled from the xr plugin code
    TriggerDelay: 2000 //how long it takes before gazing with something interacts with it
});